import { Button, Label, Spinner, Textarea } from 'flowbite-react';
import React from 'react';
import { useMutation } from 'react-query';
import { sendMessageToJobseeker } from 'src/apis/application';
import { useToast } from 'src/context/ToastProvider';

const RecruiterCandidateSendMessage = ({
	userId,
	userName,
	onSubmit,
	onFinish,
	isLoading,
	positionId,
}: {
	userId?: string;
	userName?: string;
	positionId?: string;
	isLoading?: boolean;
	onSubmit?: (data: { message: string }) => void;
	onFinish?: () => void;
}) => {
	const toast = useToast();
	const [message, setMessage] = React.useState('');

	const sendMessageToJobseekerFn = useMutation(['sendMessageToJobseeker'], sendMessageToJobseeker, {
		onSuccess() {
			toast({
				title: `Message sent to ${userName}`,
				type: 'success',
			});
			setMessage('');
			onFinish && onFinish();
		},
		onError(error: Error) {
			toast({
				title: `Error occured ${error.message}`,
				type: 'error',
			});
		},
	});
	return (
		<form
			onSubmit={e => {
				e.preventDefault();
				if (onSubmit) onSubmit({ message });
				else sendMessageToJobseekerFn.mutate({ userId: userId ?? '', positionId: positionId ?? '', message });
			}}
		>
			<div className="mb-[8px] flex justify-between items-end">
				<div>
					<Label>{'Your message '}</Label>
					<span className="text-[red]">*</span>
				</div>

				<span className="italic text-xs text-[#6B7280] ">{(message?.length || 0) + ' / ' + 640}</span>
			</div>

			<Textarea
				name="message"
				maxLength={640}
				value={message}
				placeholder="Write text here ..."
				className="border bg-white dark:text-white dark:border-[#4B5563] min-h-[185px] dark:bg-[#374151] focus:border-transparent focus:!ring-[1px] focus:!ring-[#7777E7]"
				onChange={e => {
					setMessage(e.target.value);
				}}
			></Textarea>

			<Button
				type="submit"
				className="w-full mt-[20px] bg-[#7777E7]"
				color="purplePlaced"
				// isProcessing={sendMessageToJobseekerFn.isLoading}
				disabled={sendMessageToJobseekerFn.isLoading || !message || isLoading}
			>
				{isLoading || sendMessageToJobseekerFn.isLoading ? <Spinner /> : 'Send Message'}
			</Button>
		</form>
	);
};

export default RecruiterCandidateSendMessage;
